export default class ObjectUtils
{
	static filter(object:object, keys, remove = false)
	{
		let newObject = {};
		keys = [].concat(keys);
		for(let [k, v] of Object.entries(object))
		{
			if((keys.indexOf(k) >= 0) != remove)
			{
				newObject[k] = v;
			}
		}
		return newObject;
	}

	// static hasKey()

	static findAll(object:object, keys, recursive = false):any[]
	{
		let items = [];
		keys = [].concat(keys);
		let found = true;
		for(let k of keys)
		{
			if(!object.hasOwnProperty(k))
			{
				found = false;
				break;
			}
		}
		if(found)
		{
			items.push(object);
		}
		if(recursive)
		{
			for(let [k, v] of Object.entries(object))
			{
				if(v instanceof Object)
				{
					items = items.concat(ObjectUtils.findAll(v, keys, recursive));
				}
			}
		}
		return items;
	}

	static replaceInternals(object:object, initial:object = null)
	{
		if(!initial) initial = object;
		let found = false;
		for(let [k, o] of Object.entries(object))
		{
			if(!o || typeof(o) != 'object') continue;
			if(o.hasOwnProperty('_internal'))
			{
				let newObj = {};
				let internalObj = this.getByPath(initial, o['_internal']);
				if(Array.isArray(internalObj))
				{
					newObj = internalObj;
				}else
				{
					Object.assign(newObj, internalObj, o);
					newObj = ObjectUtils.filter(newObj, ['_internal'], true);
				}
				object[k] = newObj;
			}else
			{
				this.replaceInternals(o, initial);
			}
		}
	}

	static getByPath(object, path):any
	{
		let parts = path.split('.');
		let paths = [];
		let tp = [];
		parts.forEach((p) => {
			tp.push(p);
			paths.push(tp.join('.'));
		});
		paths.reverse();
		let foundPath = paths.find((p) => {
			if(object[p]) return true;
		});
		paths.reverse();
		if(foundPath)
		{
			if(foundPath == path)
			{
				return object[foundPath];
			}else
			{
				return this.getByPath(object[foundPath], parts.slice(paths.indexOf(foundPath) + 1).join('.'));
			}
			return;
		}
		return null;
	}
}